import {
  TextField,
  Box,
  Grid,
  Typography,
  useTheme,
  FormControl,
  FormLabel,
  Button,
  IconButton,
  Stack,
  FormControlLabel,
  Tooltip,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Breadcrumbs,
  LinearProgress,
  Chip,
  Paper,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { Formik } from "formik";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
  ApprovalVerify,
  getFetchData,
  postData,
  requestMail,
} from "../../store/reducers/Formapireducer";
import React, { useState, useEffect, useRef } from "react";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { tokens } from "../../Theme";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Employeeautocomplete,
  Productautocomplete,
} from "../../ui-components/global/Autocomplete";
import { formGap } from "../../ui-components/global/utils";
import FileUploadIconButton from "../../ui-components/FileUploadButton";
import { attachmentPost } from "../../store/reducers/LoginReducer";
import axios from "axios";
import store from "../..";
import ESS from "../../assets/img/esslogo6.png";
import CryptoJS from "crypto-js";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { mailNotify } from "../../store/reducers/Listviewapireducer";

const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte IV
function decryptDataUrlSafe(urlSafeBase64) {
  // Convert back to standard base64
  let base64 = urlSafeBase64.replace(/-/g, "+").replace(/_/g, "/");
  // Add padding if needed
  while (base64.length % 4 !== 0) {
    base64 += "=";
  }

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(base64) },
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}

const DailyTaskApproval = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  let params = useParams();
  const dispatch = useDispatch();
  var recID = decryptDataUrlSafe(params.id);

  var mode = params.Mode;
  const data = useSelector((state) => state.formApi.Data);
  const Status = useSelector((state) => state.formApi.Status);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const Msg = useSelector((state) => state.formApi.msg);
  const loading = useSelector((state) => state.formApi.getLoading);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const YearFlag = sessionStorage.getItem("YearFlag");
  const EMPID = sessionStorage.getItem("EmpId");
  const Year = sessionStorage.getItem("year");
  const location = useLocation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const [loadingss, setLoading] = useState(false);
  useEffect(() => {
    dispatch(getFetchData({ accessID: "TR132", get: "get", recID }));

    var url = store.getState().globalurl.empGetAttachmentUrl;

    axios
      .get(url, {
        params: {
          empId: EMPID,
          appId: recID,
        },
      })
      .then((response) => {
        setFiles(response.data);
      })
      .catch((err) => {
        setError("Failed to fetch attachments.");
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0
  const yyyy = today.getFullYear();

  const assigneddDate = `${dd}-${mm}-${yyyy}`;

  const dailyTaskInitialValue = {
    code: "0",
    description: data.Name,
    date: data.TaskDate, // Ensures initial date follows DD-MM-YYYY
    status: data.Status == "RJ" ? "RJ" : "AP",
    Comment: data.Comments,
    sortOrder: data.SortOrder,
    disable: data.Disable === "Y",
    ProName: data.ProjectName,
    estimatedHours: data.Estimatehourse,
    actualHours: data.ActualHourse,
    empDate: data.TransferDate,
    employee: data.ToEmployeeID
      ? { RecordID: data.ToEmployeeID, Name: data.ToEmployeeName }
      : null,
    empCode: data.EmployeeCode,
    empName: data.EmployeeName,
    assignedDate: data.AssignedDate,
    assignedPerson: data.AssignedPerson,
    TaskPriority: data.TaskPriority,
    TargetDate: data.TargetDate,
    TaskType: data.TaskType,
    password: "",
    ManagerComments: data.ManagerComments ? data.ManagerComments : "",
  };

  const DTSaveFn = async (values) => {
    let action = mode === "A" ? "insert" : "update";
    const isCheck = values.disable ? "Y" : "N";

    const idata = {
      parentID: data.EmployeesID,
      RecordID: 6659,
      Code: "0",
      Name: values.description,
      TaskDate: values.date,
      Estimatehourse: values.estimatedHours || data.Estimatehourse,
      ActualHourse: values.actualHours || data.ActualHourse,
      Status: values.status,
      Comments: values.Comment.replace(/\s+/g, " ").trim(),
      SortOrder: "0",
      Disable: isCheck,
      EmpDate: values.empDate,
      FromEmployeeID: 0,
      EmployeesID: data.EmployeesID,
      EmployeeName: values.empName,
      ToEmployeeID: data.ToEmployeeID || 0,
      TransferDate: values.empDate || "",
      FunctionsID: 0,
      ProjectID: values.ProName?.RecordID || 0,
      ProjectName: values.ProName || "",
      AssignedBy: data.AssignedBy,
      AssignedDate: data.AssignedDate,
      TaskPriority: values.TaskPriority ? values.TaskPriority : "",
      TargetDate: values.TargetDate ? values.TargetDate : data.TaskDate,
      TaskType: values.TaskType ? values.TaskType : "",
      ManagerComments: values.ManagerComments ? values.ManagerComments : "",
    };

    const response = await dispatch(
      ApprovalVerify({
        action: "update",
        DailyTaskRecordID: recID,
        ApprovedBy: params.managerID,
        Status: values.status,
        PASSWORD: values.password,
        ManagerComments: values.ManagerComments ? values.ManagerComments : "",
      })
    );
    if (response.payload.Status === "Y") {
      // dispatch(mailNotify({
      //   EmployeeID: data.EmployeeID,
      //   ManagerID: params.managerID,
      //   Reason: "",
      //   RecordID: recID,
      //   Source: "M",
      //   Status: values.status == "AP" ? "Y" : values.status == "RJ" ? "N" : "Q",
      //   Type: "T"
      // })
      // );
      toast.success(response.payload.Msg);
      navigate(`/approval/notification/T/${values.status}`);
    } 
    else {
      console.log("🚀 ~ DTSaveFn ~ response.payload.Msg:", response.payload.Msg)
      toast.error(response.payload.Msg);
    }
  };

  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Box display="flex" borderRadius="3px" alignItems="center">
            <Box display={"flex"} borderRadius="3px" alignItems="center">
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default" }}
              >
                Task Approval
              </Typography>
            </Box>
          </Box>
          <Box display="flex">
            <img src={ESS} style={{ height: "50px", width: "60px" }} />
          </Box>
        </Box>
      </Paper>

      {!getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={dailyTaskInitialValue}
            onSubmit={(values, setSubmitting) => {
              setTimeout(() => {
                DTSaveFn(values);
              }, 100);
            }}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    name="empCode"
                    type="text"
                    id="empCode"
                    label="Employee Code"
                    variant="standard"
                    focused
                    value={values.empCode}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.empCode && !!errors.empCode}
                    helperText={touched.empCode && errors.empCode}
                    sx={{ gridColumn: "span 2", background: "" }}
                    inputProps={{ readOnly: true }}
                  />

                  <TextField
                    name="empName"
                    type="text"
                    id="empName"
                    label="Employee Name"
                    variant="standard"
                    focused
                    value={values.empName}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{ gridColumn: "span 2", background: "" }}
                    inputProps={{ readOnly: true }}
                  />
                  <TextField
                    name="date"
                    type="date"
                    id="date"
                    label="Date"
                    variant="standard"
                    inputFormat="DD-MM-YYYY"
                    focused
                    value={values.date}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.date && !!errors.date}
                    helperText={touched.date && errors.date}
                    sx={{ gridColumn: "span 2", background: "" }}
                    inputProps={{ readOnly: true }}
                  />
                  <TextField
                    name="description"
                    type="text"
                    id="description"
                    label="Description"
                    variant="standard"
                    focused
                    value={values.description}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.description && !!errors.description}
                    helperText={touched.description && errors.description}
                    sx={{ gridColumn: "span 2" }}
                    inputProps={{ readOnly: true }}
                  />

                  <TextField
                    name="ProName"
                    type="text"
                    id="ProName"
                    label="Project"
                    variant="standard"
                    focused
                    value={values.ProName}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{ gridColumn: "span 2" }}
                    inputProps={{ readOnly: true }}
                  />

                  <TextField
                    name="estimatedHours"
                    type="number"
                    id="estimatedHours"
                    label="Estimated Hours"
                    multiline
                    variant="standard"
                    fullWidth
                    focused
                    value={values.estimatedHours}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!touched.estimatedHours && !!errors.estimatedHours}
                    helperText={touched.estimatedHours && errors.estimatedHours}
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      readOnly: true,
                      inputProps: { style: { textAlign: "right" } },
                    }}
                  />
                  <TextField
                    name="actualHours"
                    type="number"
                    id="actualHours"
                    label="Actual Hours"
                    multiline
                    variant="standard"
                    fullWidth
                    focused
                    value={values.actualHours}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!touched.actualHours && !!errors.actualHours}
                    helperText={touched.actualHours && errors.actualHours}
                    sx={{ gridColumn: "span 2" }}
                    InputProps={{
                      readOnly: true,
                      inputProps: { style: { textAlign: "right" } },
                    }}
                  />

                  <FormControl

                    focused
                    variant="standard"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="status3">Type</InputLabel>
                    <Select
                      labelId="status3"
                      id="TaskType"
                      name="TaskType"
                      value={values.TaskType}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputProps={{ readOnly: true }}
                    >
                      <MenuItem value="Normal">Normal</MenuItem>
                      <MenuItem value="Learning&development">
                        Learning & development
                      </MenuItem>
                      <MenuItem value="Research&development">
                        Research & development
                      </MenuItem>
                      <MenuItem value="Up-skill">Up-skill</MenuItem>
                      <MenuItem value="Bug">Bug</MenuItem>
                      <MenuItem value="Improvements">Improvements</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    name="assignedDate"
                    type="date"
                    id="assignedDate"
                    label="Assigned Date"
                    variant="standard"
                    focused
                    value={values.assignedDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{ gridColumn: "span 2" }}
                    inputProps={{ readOnly: true }}
                  />

                  <TextField
                    fullWidth
                    name="TargetDate"
                    type="date"
                    id="TargetDate"
                    label="Target Date"
                    variant="standard"
                    focused
                    format="MM-DD-YYYY"
                    value={values.TargetDate}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    sx={{ gridColumn: "span 2", background: "" }}
                    inputProps={{ readOnly: true }}

                  />
                  <FormControl

                    focused
                    variant="standard"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="status2">Priority</InputLabel>
                    <Select
                      labelId="status2"
                      id="TaskPriority"
                      name="TaskPriority"
                      value={values.TaskPriority}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputProps={{ readOnly: true }}
                    >
                      <MenuItem value="Low">Low</MenuItem>
                      <MenuItem value="Medium">Medium</MenuItem>
                      <MenuItem value="High">High</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    focused
                    variant="standard"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="status">Status</InputLabel>
                    <Select
                      disabled={mode === "V" || mode == "TO"}
                      labelId="demo-simple-select-filled-label"
                      id="status"
                      name="status"
                      value={mode == "TO" ? "T" : values.status}
                      onBlur={handleBlur}
                      onChange={handleChange}
                    >
                      <MenuItem value="AP">Approved</MenuItem>
                      <MenuItem value="RJ">Rejected</MenuItem>
                      {/* <MenuItem value="QR">Query</MenuItem> */}
                    </Select>
                  </FormControl>
                </Box>
                <Box padding={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        disabled={mode === "V"}
                        name="Comment"
                        type="text"
                        id="Comment"
                        label="Comment"
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        focused

                        value={values.Comment}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={!!touched.Comment && !!errors.Comment}
                        helperText={touched.Comment && errors.Comment}
                        sx={{ gridColumn: "span 2" }}
                        inputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        disabled={mode === "V"}
                        name="ManagerComments"
                        type="text"
                        id="ManagerComments"
                        label="Manager Comments"
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        focused
                        required
                        value={values.ManagerComments}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{ gridColumn: "span 2" }}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  display="flex"
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                  padding={1}
                  flexDirection={isNonMobile ? "row" : "column"}
                >
                  {data.Status == "AP" && (
                    <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                      Your Task has been Approved.
                    </Alert>
                  )}

                  {data.Status == "RJ" && (
                    <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                      Your Task has been Rejected.
                    </Alert>
                  )}
                  {data.Status == "QR" && (
                    <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                      Your Task has been Queried.
                    </Alert>
                  )}
                  <TextField
                    required
                    name="password"
                    type="password"
                    id="password"
                    label="Password"
                    variant="standard"
                    focused
                    value={values.password}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    fullWidth={isNonMobile ? false : true}
                    sx={{ gridColumn: "span 2", width: 300 }}
                     inputProps={{ readOnly: data.Status == "AP" || data.Status == "RJ" ? true : false }}
                  />
                  <LoadingButton
                    disabled={data.Status == "AP" || data.Status == "RJ"}
                    color="success"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                  >
                    Submit
                  </LoadingButton>
                </Box>

              </form>
            )}
          </Formik>
          <Box m={1} display="flex" gap={2}>
            {/* Left Side: Upload File Table */}
            {mode === "E" && files.length > 0 ? (
              <Box flex={1} >
                <Paper elevation={3} sx={{ padding: 2 }}>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell width={20}><strong>S.No</strong></TableCell>
                          <TableCell><strong>Uploaded Date</strong></TableCell>
                          <TableCell><strong>Filename</strong></TableCell>
                          <TableCell><strong>Source</strong></TableCell>
                          <TableCell><strong>View</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {files.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={5} align="center">No files uploaded yet.</TableCell>
                          </TableRow>
                        ) : (
                          files.map((file, index) => (
                            <TableRow key={file.id || index}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{file.uploadedDate}</TableCell>
                              <TableCell>{file.filename}</TableCell>
                              <TableCell>{file.source}</TableCell>
                              <TableCell>
                                <Tooltip title="Open File">
                                  <IconButton
                                    color="primary"
                                    component="a"
                                    href={file.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    size="small"
                                  >
                                    <OpenInNewIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
            ) : null}

          </Box>
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default DailyTaskApproval;
